<template>
  <div class="patient-header" :class="mode">
    <div>
      <div class="smd-profile-image" :class="small ? 'm' : 'l'">
          {{initials}}
      </div>
      <div class="patient-data">
        <div class="patient-data__details">

          <label dark v-if="!small">{{patient._id ? patient._id : '0000'}}</label>

          <div class="patient-data__name">
            <h2 v-if="!!patientcase._id">PCRN # {{patientcase._id}}</h2>
            <h2 v-else>New Case</h2>
          </div>

          <div class="patient-data__meta">
            <p><label>DOB:</label> {{patient.birthDate | formatDate}}</p>
            <p><label>AGE:</label> {{patient.birthDate | computeAge}}</p>
          </div>
        </div>
      </div>
    </div>
    <div v-if="small">
      <label v-if="title" >{{title}}</label>
    </div>
    <div class="actions">
      <div>
        <slot name="actions"/>
        <smd-btn icon="smd-icon-action-close" @click="$emit('close')"/>
      </div>
      <div v-if="!small">
        <slot name="bottomActions"/>
      </div>
    </div>
  </div>
</template>

<script>
  import SmdButton from "../../../scaffolding/smd-button";

  export default {
    name: "case-header",
    components: {SmdButton},
    props:{
      mode: {type: String, default: 'small'},
      title: String,
      patient: null,
      patientcase: null
    },
    data(){
      return{
        small: false
      }
    },
    watch:{
      'mode': function(newVal){
        this.updateMode(newVal);
      }
    },
    methods:{
      updateMode(value){
        this.small = value === 'small' ? true : false;
      },
      edit(e) {
        this.$emit('edit',e)
      }
    },
    computed:{
      initials(){
        return this.patient.firstName ? this.patient.firstName.substring(0,2) : ' ';
      }
    },
    mounted(){
      this.updateMode(this.mode);
    }
  }
</script>

<style lang="scss">

  @import "../../../scaffolding/scss/pogs-util";

  .patient-header{
    @extend %align-items-center;
    @include make-grid-cols(repeat(2,1fr));
    @include space-me($prop: margin, $b: base);

    &:not(.small) > div:first-child{
      @include make-grid-cols(80px 1fr, space(m));
      @include space-me($t: s, $b: s);
    }


    &:not(.small) .patient-data__name{
      margin-top: -5px;
    }

    .patient-data__name{
      @extend %flex-row--center-x;

      button{
        @include space-me($prop: margin, $l: base);
      }
    }

    .actions {
      @include make-grid-rows(1fr, space(m));
      align-self: flex-start;

      & > div{
        @extend %flex, %align-self-flex-start, %justify-content-flex-end;
        min-height: 36px;

        & > *:not(:last-child){
          margin-right: space(s);
        }
      }
    }
  }

  .patient-header{
    &.small{
      grid-template-columns: repeat(3, 1fr);
      max-height: 60px;
      margin-bottom: 0;

      & > div:first-child{
        @include make-grid-cols(40px 1fr, space(m));
      }

      & > div:nth-child(2){
        @extend %flex, %justify-content-center;
        align-self: flex-end;
      }

      .actions{
        & > div{
          @extend %flex-row--center-x, %justify-content-flex-end;
        }
      }

      .patient-data__details{
        p{font-size: font(s);}

        & > div:nth-child(2){
          grid-template-columns: 150px 60px;
          padding-top: 3px;
        }
      }
    }
  }

</style>
